import { render, staticRenderFns } from "./ProductsListWidget.vue?vue&type=template&id=b1048ecc&"
import script from "./ProductsListWidget.vue?vue&type=script&lang=js&"
export * from "./ProductsListWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports